import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: '' };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      //logErrorToMyService(error, errorInfo);
      //console.log('error: ' + error + 'info: ' + errorInfo)      
      this.setState({error: error });
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <h1>
            Uh oh, something broke: {this.state.error}
            {/* Uh oh, something broke */}
        </h1>;
      }
  
      return this.props.children; 
    }
}

export default ErrorBoundary